import { Component, OnInit } from '@angular/core';
import {CollectionService} from '../services/collection.service';
import {ToastService} from 'angular-toastify';
import {CollectionCaseContainer, CollectionCustomer, Customer} from '../../dto/customer';
import {AddressStatus, IdentLevel, IdentStatus} from '../../dto/ident-status';
import {PepStatus} from '../../dto/pep-status';
import {GpsCardStatusHelper} from '../../dto/gps-card-status';
import {CardReorderReason} from '../../dto/card-reorder-reason';
import {PHONE_MASK} from '../../helpers/format-helpers';
import {ContentRowField} from '../../shared/content-row/content-row.component';
import {formatPhoneNumeric, phoneToCountry, toDateString, toDateTimeString} from '../../providers/app-date-adapter';
import {WebIdTransaction} from '../../dto/web-id-transaction';
import {Order} from '../../dto/order';
import {Card, CustomerOverviewCardContainer} from '../../dto/card';
import {CollectionInvoice, Invoice} from '../../dto/invoice';
import {byNumeric} from 'iso-country-codes';
import {EmailSendStatus} from '../../dto/order-status';
import {Upload} from '../../dto/upload';
import {CityInfo} from '../../dto/GeoIp/city-info';
import {GeoIpService} from '../../services/geo-ip.service';
import {BankTransferLoad} from '../../dto/bankTransferLoad';
import {IdvUploadDto} from '../../dto/idv-upload';
import {ActivatedRoute} from '@angular/router';
import {CardView, CollectionCardView} from '../../dto/cardView';
import {FileHelper} from '../../helpers/file-helper';
import {
  getIdentStatusColor,
  getIdentStatusIcon, getIdentStatusText,
  getPepStatusColor,
  getPepStatusText
} from "../../helpers/pep-status-helper";

@Component({
  selector: 'app-collection-search',
  templateUrl: './collection-search.component.html',
  styleUrls: ['./collection-search.component.css']
})
export class CollectionSearchComponent implements OnInit {
  caseNumber = '';
  isBusy = false;
  caseData: CollectionCaseContainer;
  customer: CollectionCustomer|null;
  orders: Order[] = [];
  cards: CollectionCardView[] = [];
  invoices: CollectionInvoice[] = [];
  addressUploadFiles: Upload[] = [];

  isLoadingCustomer = false;

  identStatus = IdentStatus;
  pepStatus = PepStatus;
  cardReorderReason = CardReorderReason;

  private ipCityInfo: CityInfo|null;

  gpsCardStatusHelper = GpsCardStatusHelper;

  cancellationFields = [
    {header: 'Cancellation reason', cell: (row: Order) => `${row.cancellationReasonName}`},
    {header: 'Cancellation comment', cell: (row: Order) => `${row.cancellationComment}`},
    // { header: "Cancellation comment", cell: (row: Order) => `${row.cancellationComment}` },
    {header: 'Cancellation date', cell: (row: Order) => `${toDateTimeString(row.cancellationDate) || ''}`},

  ];

  cancellationExtraFields = [
    {header: 'User Cancellation reason', cell: (row: Order) => `${row.userCancellationReasonName}`},
    {
      header: 'User Cancellation comment', cell: (row: Order) => {

        if (row.cancellationComment == null) {
          return '-';
        } else {
          row.cancellationComment;
        }

      }
    },
  ];

  constructor(
    private collectionService: CollectionService,
    private _toastService: ToastService,
    private geoIpService: GeoIpService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {

    this.route.queryParams
      .subscribe(params => {
        if( params.caseNumber) {
this.caseNumber = params.caseNumber;
}
        }
      );

  }

  openCase(): void {

    this.isBusy = true;
    this.collectionService.getCase(this.caseNumber).subscribe(d => {
      this.caseData = d;
      this.customer = this.caseData.customer;
      this.orders = this.caseData.orders;
      this.invoices = this.caseData.invoices;
      this.cards = this.caseData.cards;
      this.isBusy = false;

      if ( this.customer.ipAddress ) {
this.geoIpService.getCityByIp(this.customer.ipAddress).subscribe(city => this.ipCityInfo = city, err => {});
}

      this.isLoadingIdentLog = true;
      this.collectionService.getIdents(this.customer.id).subscribe(data => {
        this.isLoadingIdentLog = false;
        this.idents = data;
      });

      this.isLoadingAllDocuments = true;
      this.collectionService.getAllDocuments(this.customer.id).subscribe(data => {
        this.allDocuments = data;
        this.isLoadingAllDocuments = false;
      });


    }, error => {
      this.isBusy = false;
      if ( error.status == 404 ) {
        this._toastService.error('No case data found for this input');
        return;
      }

      this._toastService.error(error.message);

    });
  }

  downloadPdf() {
    this.collectionService.getCasePdf( this.caseNumber ).subscribe(
      result => {
        FileHelper.saveFile( result );
      },
      err =>
        this._toastService.error(err.error.message || err.message || err.error || err)
    );
  }

  closeCase() {
    this.caseData = null;

    this.customer = null;
    this.orders = [];
    this.invoices = [];
    this.cards = [];

    // TODO notify backend for logging
  }

  protected readonly IdentLevel = IdentLevel;
  protected readonly PepStatus = PepStatus;
  protected readonly GpsCardStatusHelper = GpsCardStatusHelper;
  protected readonly CardReorderReason = CardReorderReason;
  protected readonly AddressStatus = AddressStatus;
  protected readonly PHONE_MASK = PHONE_MASK;
  protected readonly IdentStatus = IdentStatus;
  protected readonly Number = Number;


  fields = [
    {header: 'Name', cell: (row: Customer) => `${row.title || ''} ${row.firstName} ${row.lastName}`} as ContentRowField<Customer>,
    /*{ header: "Title", cell: (row: Customer) => `${row.title}` },
    { header: "First name", cell: (row: Customer) => `${row.firstName || ""}` },
    { header: "Last name", cell: (row: Customer) => `${row.lastName || ""}` },*/
    {header: 'Address', cell: (row: Customer) => `${row.address || ''}, ${row.zipCode || ''} ${row.city || ''}`},
    {header: 'Country', cellFlag: (row: Customer) => byNumeric[row.countryIsoCode.toString().padStart(3, '0')].alpha2, cell: (row: Customer) => `${row.countryName || ''}`},
    /*{ header: "Address", cell: (row: Customer) => `${row.address || ""}` },
    { header: "City", cell: (row: Customer) => `${row.city || ""}` },
    { header: "Zip code", cell: (row: Customer) => `${row.zipCode || ""}` },*/
    { header: 'Email',
      icon: (row: Customer) => this.getEmailIcon(row),
      cellColor: (row: Customer) => this.getEmailIconColor(row),
      iconColor: (row: Customer) => this.getEmailIconColor(row),
      cell: (row: Customer) => `${row.email || ''}`
    },


    {header: 'Mobile', cellFlag: (row: Customer) => phoneToCountry(''+row.phone), cell: (row: Customer) => `+${row.phone || ''}`},
    {header: 'Date of birth', cell: (row: Customer) => {
        if ( !row.dob ) {
          return '-';
        }
        return toDateString(row.dob);
      }},
    /*{header: "Age", cell: (row: Customer) => {
        if ( !row.dob )
          return "-";
        return toAge(row.dob) + " years"
      }},*/
    {
      header: 'Order language'
      , cellFlag: (row: Customer) => {
        if (row.orderLanguage == 0) {
          return 'de';
        } else {
          return 'gb';
        }
      }

      , cell: (row: Customer) => {
        if (row.orderLanguage == 0) {
          return 'german';
        } else {
          return 'english';
        }
      }
    },
    {header: 'IP Address', cellFlag: (row: Customer) => this.ipCityInfo?.countryAlphaIsoCode || null
      , cell: (row: Customer) => {
        const ret = row.ipAddress || '';
        if ( ret && this.ipCityInfo ) {
          //ret += " (" + this.ipCityInfo.postCode + " " + this.ipCityInfo.city + " " + this.ipCityInfo.countryName + ")"
        }
        return ret;

      }},
    {header: 'Referral Code', cell: (row: Customer) => row.referralCode},
    {header: 'Subscribed to news', cell: (row: Customer) => `${row.subscribeToNews ? 'Yes' : 'No' || ''}`},
    {
      header: 'Ident',
      iconColor: row => getIdentStatusColor(row.identStatus),
      icon: (row: Customer) => getIdentStatusIcon(row.identStatus),
      cell: row => getIdentStatusText(row.identStatus),
    } as ContentRowField<Customer>,
    {
      header: 'PEP Status',
      iconColor: (row: Customer) => getPepStatusColor(row.pepStatus), icon: (row: Customer) => 'perm_identity',
      cell: (row: Customer) => getPepStatusText(row.pepStatus),
    },
    {
      header: 'Address Status',
      iconColor: (row: Customer) => {

        if (row.addressStatus == AddressStatus.Confirmed) {
return '#8bc34a';
}
        if (row.addressStatus == AddressStatus.WaitingForDocuments) {
return '#4a82c3';
}
        if (row.addressStatus == AddressStatus.PendingCheck) {
return '#684ac3';
}

        return '#d04848';
      },
      icon: (row: Customer) => {
        if (row.addressStatus == AddressStatus.Confirmed) {
return 'place';
}
        if (row.addressStatus == AddressStatus.WaitingForDocuments) {
return 'not_listed_location';
}
        if (row.addressStatus == AddressStatus.PendingCheck) {
return 'not_listed_location';
}

        return 'not_listed_location';
      }, cell: (row: Customer) => {
        if (row.addressStatus == AddressStatus.Confirmed) {
return 'Confirmed';
}
        if (row.addressStatus == AddressStatus.WaitingForDocuments) {
return 'Waiting for documents';
}
        if (row.addressStatus == AddressStatus.PendingCheck) {
return 'Pending check';
}

        return 'Unconfirmed';
      }},
    /*{
      header: "IDV Link Status", cell: (row: Customer) => {
        if (row.idvSuccess == null) {
          return "-";
        }
        if (row.idvSuccess) {
          return "Success";
        } else {
          return "Failed";
        }
      }
    },
    {
      header: "Docs Link Status", cell: (row: Customer) => {
        if (row.docsSuccess == null) {
          return "-";
        }
        if (row.docsSuccess) {
          return "Success";
        } else {
          return "Failed";
        }
      }
    },*/

  ] as ContentRowField<Customer>[];

  cardFields = [
    {
      header: 'Card Token',

      cell: (row: CardView) => `${row.token}`,
      copyCellActive: (row: CardView) => true
    },
    //{header: "Status", cell: (row: CardView) => `${this.gpsCardStatusHelper.getIcon(row.gpsCardStatusCached)} ${this.gpsCardStatusHelper.getText(row.gpsCardStatusCached)}`},
    {header: 'Creation date', cell: (row: CardView) => `${toDateTimeString(row.creationDate) || ''}`},
    {header: 'Shipping date', cell: (row: CardView) => `${toDateString(row.shippedDate) || ''}`},
    {
      header: 'Order cancellation date', cell: (row: CardView) => {
        if ( row == null ) {
          return '';
        }

        if ( row.orderCancellationDate != null ) {

          if (row.creationDate != null) {
            const cancellationDate = new Date(row.orderCancellationDate);
            const createDate = new Date(row.creationDate);

            const dontAllowCancellationDate = new Date(createDate);
            dontAllowCancellationDate.setDate(createDate.getDate() + 21);
            // console.log("d: " + dontAllowCancellationDate);

            if (cancellationDate <= dontAllowCancellationDate) {
              return toDateString(row.orderCancellationDate) + ' (revocation)';
            } else {
              return toDateString(row.orderCancellationDate) + ' (cancellation)';
            }
          }

        } else {
          return '';
        }
      }
    },
    {header: 'Activation date', cell: (row: CardView) => `${toDateTimeString(row.activationDate) || ''}`},
    {header: 'Order date', cell: (row: CardView) => `${toDateString(row.orderDate) || ''}`},
    { header: 'Next Annual Fee', cell: (row: CardView) => `${toDateString(row.nextAnnualFeeDate) || ''}` } as ContentRowField<CardView>,


    {header: 'Order', cell: (row: CardView) => `${row.orderId || ''}`},

    {header: 'PAN', cell: (row: CardView) => `${row.maskedPAN || '(unknown)'}`},
    {header: 'Card Type', cell: (row: CardView) => `${row.cardTypeName || '(unknown)'}`},


  ] as ContentRowField<CardView>[];

  ordersFields = [
    {header: 'Order date', cell: (row: Order) => `${toDateString(row.orderDate) || ''}`},
    {header: 'Shipping date', cell: (row: Order) => `${toDateString(row.shippedDate) || ''}`},
    {header: 'Status', cell: (row: Order) => `${row.statusName || ''}`},
    {
      header: 'Cancellation Status', cell: (row: Order) => {
        if (row.cancellationStatus != null && row.cancellationStatus == 1) {
          return 'Pending';
        }
        if (row.cancellationStatus != null && row.cancellationStatus == 2) {
          return 'Done';
        }
        return '-';

      }
    },

    // { header: "WebID status", cell: ( row: number ) => `${ WebIdTransactionStatus[(this.orders[row].order.webIdTransaction || ({} as WebIdTransaction)).status] || "WebID Was not required" }` },

  ] as ContentRowField<Order>[];


  ordersFields2 = [
    // { header: "ExternalRef", cell: (row: Order) => `${row.externalRef}` },
    // { header: "Card name", cell: (row: Order) => `${row.cardName}` },
    // { header: "Invoice number", link: (row: Order) => (row ? `/invoices/by-number/${row.invoiceNumber}` : null), cell: (row: Order) => `${row.invoiceNumber || "Voucher"}` },
    {header: 'Sex', cell: (row: Order) => `${row.sex}`},

    {header: 'Name', cell: (row: Order) => `${row.title} ${row.firstName} ${row.lastName}`},
    {header: 'Company', cell: (row: Order) => `${row.customerCompanyName != null ? row.customerCompanyName : '-'}`},
    /*{ header: "Title", cell: (row: Order) => `${row.title}` },
    { header: "First Name", cell: (row: Order) => `${row.firstName}` },
    { header: "Last Name", cell: (row: Order) => `${row.lastName}` },*/

    {header: 'Date of birth', cell: (row: Order) => `${toDateString(row.dob) || ''}`},
    {header: 'Email', cell: (row: Order) => `${row.email}`},
    {header: 'Mobile', cellFlag: (row: Order) => phoneToCountry(''+row.phone), cell: (row: Order) => `${formatPhoneNumeric(row.phone)}`},
    {header: 'Product', cell: (row: Order) => `${row.productName}`},
    {header: 'Company', cell: (row: Order) => `${row.companyName}`},

    {header: 'Address', cell: (row: Order) => `${row.address}, ${row.zipCode} ${row.city}`},
    /*
    { header: "Address", cell: (row: Order) => `${row.address}` },
    { header: "City", cell: (row: Order) => `${row.city}` },
    { header: "Zip Code", cell: (row: Order) => `${row.zipCode}` },
    */
    {header: 'Country', cell: (row: Order) => `${row.countryName}`},
    {header: 'Nationality', cell: (row: Order) => `${row.nationality}`},
    {
      header: 'Order language', cell: (row: Order) => {
        if (row.orderLanguage == 0) {
          return 'german';
        } else {
          return 'english';
        }
      }
    },

    { header: 'Load amount', icon: (row: Order) => {
        if ( row.loadAmount > 0 ) {
          return 'caret-right-circle';
        }
        return null;
      },
      iconColor: (row: Order) => {
        if ( row.loadAmount > 0 ) {
          return 'dodgerblue';
        }
        return null;
      }, cell: (row: Order) => `${row.loadAmount || ''}` } as ContentRowField<Order>,


    {header: 'Ip Address', cell: (row: Order) => `${row.ipAddress}`},
    {header: 'Order date', cell: (row: Order) => `${toDateString(row.orderDate) || ''}`},
    {header: 'Shipping date', cell: (row: Order) => `${toDateString(row.shippedDate) || ''}`},
    {header: 'Status', cell: (row: Order) => `${row.statusName}`},
    {
      header: 'Voucher Code', cell: (row: Order) => {
        if (row.voucherCode != null) {
          return row.voucherCode;
        }
        return '-';
      }
    },

    {
      header: 'Ident Txn ID',
      cell: (row: Order) => `${(row.webIdTransaction || ({} as WebIdTransaction)).id || 'No Ident'}`
    },
    {
      header: 'Ident Status',
      cell: (row: Order) => `${IdentStatus[(row.webIdTransaction || ({} as WebIdTransaction)).status] || 'No Ident'}`
    },

  ];
  loadHistory: BankTransferLoad[] | null;
  isLoadingIdentLog = false;
  idents: WebIdTransaction[] = [];
  isLoadingIdvSof = false;
  isLoadingAllDocuments = false;
  allDocuments: IdvUploadDto[] = [];



  getIdentLevelClass() {
    if ( this.customer ) {
      switch (this.customer.identLevel) {
        case IdentLevel.Sdd:
          return 'ident-level-1';
        case IdentLevel.Fdd:
          return 'ident-level-2';
        case IdentLevel.Edd:
          return 'ident-level-3';
      }

      return 'ident-level-0';
    }
    return '';
  }
  getCurrentIdentLevel() {
    if ( this.customer ) {
      switch (this.customer.identLevel) {
        case IdentLevel.Sdd:
          return 'SDD';
        case IdentLevel.Fdd:
          return 'FDD';
        case IdentLevel.Edd:
          return 'EDD';
      }

      return 'Unknown';
    }
    return '';
  }

  getEmailIcon(row: Customer): string|boolean {
    if ( row.emailSendStatus == EmailSendStatus.Undeliverable ) {
      return 'front_hand';
    }
    if ( row.emailSendStatus == EmailSendStatus.Deliverable) {
      return 'mark_email_read';
    }
    return 'email';

  }

  getEmailIconColor(row: Customer): string|boolean {
    if ( row.emailSendStatus == EmailSendStatus.Undeliverable && row.emailRejectedCount >= 3) {
      return '#ff0000';
    }
    if ( row.emailSendStatus == EmailSendStatus.Undeliverable) {
      return '#ff9900';
    }

    if ( row.emailSendStatus == EmailSendStatus.Deliverable) {
      return '#008400';
    }

    return false;
  }

  getIdentStatusString1(status: IdentStatus) {
    return IdentStatus[status] || 'unknown';
  }

  getIdentDocumentType(identDocumentType: number): string {
    if ( identDocumentType === 0 ) {
return 'NONE';
}
    if ( identDocumentType === 1 ) {
return 'PASSPORT';
}
    if ( identDocumentType === 2 ) {
return 'DRIVERS_LICENSE';
}
    if ( identDocumentType === 3 ) {
return 'ID_CARD';
}
    if ( identDocumentType === 4 ) {
return 'RESIDENCE_PERMIT';
}

    return 'Other';
  }
  displayedStatementColumns: string[] = ['direction', 'transactionDate', 'description', 'amount', 'blockAmount', 'billAmount', 'currency', 'rateFee', 'fixedFee', 'statusDescription'];
  downloadFile(id: number) {
    this._toastService.error('not_allowed');
  }


}
